<template>
  <div>
    <!-- <el-button v-if="!disabled" @click="openSelectModal">选择终端</el-button> -->
    <!-- 输入框 -->
    <el-input
      v-model="pageData.materialName"
      placeholder="选择产品"
      @click.native="openSelectModal"
      :disabled="disabled"
      ref="inputRef"
      readonly
    ></el-input>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  components: {
    SelectConfig,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    functionCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      pageData: {},
    };
  },
  methods: {
    openSelectModal() {
      const params = {
        functionCode: this.functionCode || 'product_list',
        data: this.tableData || [],
        selectionList: this.tableData || [],
        idKey: 'materialCode',
        noReset: true,
        paramData: {
          enableStatus: '009',
          ...this.params,
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(e) {
      this.tableData = e || [];
      this.pageData = {
        ...this.pageData,
        tableData: this.tableData,
        materialCode: e && e.map((el) => el.materialCode).join(','),
        materialName: e && e.map((el) => el.materialName).join(','),
      };
      this.toFather();
    },
    toFather() {
      this.pageData = {
        ...this.pageData,
        tableData: this.tableData,
      };
      this.$emit('input', this.pageData);
      this.$emit('change', this.pageData);
    },
    removeEvent(row) {
      this.tableData = this.tableData.filter((item) => item.materialCode !== row.materialCode);
      this.toFather();
    },
    changeEvent() {
      this.pageData = {
        ...this.pageData,
        tableData: this.tableData,
      };
      this.$emit('input', this.pageData);
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.tableData = val.tableData || [];
        } else {
          this.tableData = [];
        }
        this.pageData = val || {
          tableData: [],
        };
      },
    },
    params: {
      handler(val) {},
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style></style>
